import { OPMCalculatorBreakpoint } from 'api';

/** The last rung of the ladder has no finite strike; the backend sends it as "Infinity". */
export const BREAKPOINT_INFINITY = 'Infinity';

export const isInfinityBreakpoint = (breakpoint?: OPMCalculatorBreakpoint): boolean =>
  String(breakpoint?.total) === BREAKPOINT_INFINITY;

/** Numeric breakpoint total, or 0 for the Infinity rung, which has no arithmetic meaning here. */
export const breakpointTotal = (breakpoint?: OPMCalculatorBreakpoint): number => {
  if (!breakpoint || isInfinityBreakpoint(breakpoint)) {
    return 0;
  }
  const total = Number(breakpoint.total);
  return Number.isFinite(total) ? total : 0;
};

/**
 * Column header for the allocation table: the slice this breakpoint covers, e.g.
 * "$1,308,876 to $123,262,493". The Infinity rung reads "<previous total> and above".
 */
export const breakpointRangeHeader = ({
  breakpoint,
  previousBreakpoint,
  formatCurrency,
}: {
  breakpoint: OPMCalculatorBreakpoint;
  previousBreakpoint?: OPMCalculatorBreakpoint;
  formatCurrency: (value: number) => string;
}): string => {
  const from = formatCurrency(previousBreakpoint ? breakpointTotal(previousBreakpoint) : 0);

  if (isInfinityBreakpoint(breakpoint)) {
    return `${from} and above`;
  }

  return `${from} to ${formatCurrency(breakpointTotal(breakpoint))}`;
};
